import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";
import "react-accessible-accordion/dist/fancy-example.css";
import {
  formatDateDash,
  handleCatch,
  isObject,
  verifyUserType,
} from "../../../shared/helpers";

import StyledPrescriptionAuthorisationForm from "./../PAF/StyledPAF";

import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Valid } from "../../../assets/icons/checkFilled.svg";
import { ReactComponent as Rejected } from "../../../assets/icons/rejected.svg";
import CloseIcon from "../../../assets/icons/close.svg";

import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import InfoPAF from "../../common/InfoPAF/InfoPAF";
import ViewPAF from "../../common/ViewPAF/ViewPAF";
import ConfirmationModal from "./../PAF/confirmationModal";
import { registrationCategory } from "../../../constants/register.constants";
import LocalStorage from "../../../shared/localStorage";
import axios from "axios";
import APIVariables from "../../../services/api-variables";

import Loader from "../../common/Loader/Loader";
import Footer from "../../common/Footer/Footer";

import HealthcareProfessionalInformationGuide from "./../../pages/PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";
import { errorMessages } from "../../../constants/errorMessages.constants";

const PAFDetails = () => {
  const history = useHistory();
  const { pafID } = useParams();
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const isPharmacy = verifyUserType(registrationCategory.PHARMACY);

  const [userInfo, setUserInfo] = useState([]);
  const [items, setItems] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); //errors from backend

  const [quitModalIsOpen, setIsOpenQuit] = useState(false);

  const [statePAFModal, setStatePAFModal] = useState(false);
  const [message, setMessage] = useState({
    state: 1,
    type: "",
    title: "",
    description: "",
    buttonText: "",
  });

  const [numberOfCylesValues, setNumberOfCylesValue] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const renameKeys = async (toBeRenamed) => {
    await toBeRenamed.forEach((elem) => {
      elem["label"] = elem.value;
      elem["value"] = elem.id;
      delete elem["id"];
    });
    return toBeRenamed;
  };

  useEffect(() => {
    //when we get access to endpoint /prescriptions/{ID} we have to implement from pharmacy perspective
    getPAF();
    getNumberOfCycles();
    // added window.location.pathname fixed a bug when finding a patient from top menu is not chanching the UI
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const getNumberOfCycles = async () => {
    setIsButtonDisabled(true);
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL +
          APIVariables.PRESCRIPTIONS_ACCEPT +
          pafID,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch(function (error) {
        handleCatch(error);
        const errors = error?.response?.data;
        if (typeof errors === "string") {
          setErrorMessage([errorMessages.INTERNAL_SERVER_ERROR]);
        } else {
          const errorsArray = [];
          if (!!errors) {
            Object.keys(errors).forEach((key) => {
              if (isObject(errors[key])) {
                Object.keys(errors[key]).forEach((secondKey) => {
                  errorsArray.push(key + " - " + errors[key][secondKey][0]);
                });
              } else {
                errorsArray.push(key + " - " + errors[key]);
              }
            });
            setErrorMessage(errorsArray);
          } else {
            setErrorMessage([error.message]);
          }
        }
      });

    if (res?.status === 200) {
      const dropDownValues = res?.data?.n_cycles;
      const rename = await renameKeys(dropDownValues);
      setIsButtonDisabled(false);
      setNumberOfCylesValue(rename);
    }
  };

  const getPAF = async () => {
    setIsButtonDisabled(true);
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL + APIVariables.PRESCRIPTIONS + pafID,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch(function (error) {
        handleCatch(error);
        setIsLoading(false);
      });

    if (res) {
      Object.assign(res.data, {
        confirmation: res.data.confirmation_risk_prescriber,
      });

      // IF THE PREGANACY TEST IS NULL - ADD THE CURRENT DATE
      if (res?.data?.pregnancy_test === null) {
        res.data.pregnancy_test = formatDateDash(new Date());
      }

      let infoUser = {
        ...res.data,
      };
      Object.assign(infoUser?.patient, {
        treatingHospital:
          infoUser?.prescriber?.name_and_address_hospital ||
          infoUser?.registrar?.name_and_address_hospital,
      });

      setUserInfo(infoUser?.patient);
      delete infoUser.patient;

      setItems(JSON.parse(JSON.stringify(res.data)));
    }
    setIsButtonDisabled(false);
    setIsLoading(false);
  };

  function closeForm() {
    if (isPharmacy) {
      if (items.status === "Approved" || items.status === "Rejected") {
        history.push(App.VIEW_PATIENTS);
      } else {
        setIsOpenQuit(true);
      }
    } else {
      history.push(App.VIEW_PATIENTS);
    }
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  function quitModal() {
    history.push(App.NOTIFICATIONS);
  }

  const hcpBrochure =
    process.env.NODE_ENV === "production"
      ? "https://psh-ie-files-live.s3.amazonaws.com/Healthcare_Professional_Information_Guide.pdf"
      : HealthcareProfessionalInformationGuide;

  function approveForm() {
    setIsButtonDisabled(true);
    setStatePAFModal(true);
    setMessage((prevState) => ({
      ...prevState,
      state: 3,
      type: "",
      title: "Please confirm your approval",
      description: `<div> 
<p>I am satisfied that this Lenalidomide Prescription Authorisation Form has been completed fully and that I have read and understood the <a href=${hcpBrochure} target="_blank">Lenalidomide HealthcareProfessional Information Guide.</a></p>
<p>For woman of childbearing potential, dispensing will be taking place within
7 days of the date of prescription. I am dispensing no more than 4 weeks
supply to women of childbearing potential and 12 weeks for males and women
of non-childbearing potential.</p>
</div>`,
      buttonText: "Approve",
    }));
  }

  const closeConfirmationModal = () => {
    setIsButtonDisabled(false);
    setStatePAFModal(false);
    setMessage((prevState) => ({
      ...prevState,
      state: 1,
      type: "",
      title: "",
      description: "",
      buttonText: "",
    }));

    getPAF();
    getNumberOfCycles();
  };

  function rejectForm() {
    setStatePAFModal(true);
    setMessage((prevState) => ({
      ...prevState,
      state: 2,
      type: "error",
      title: "State the Reason for Rejection",
      description: "",
      buttonText: "Reject",
    }));
  }

  const submitError = () => {
    setMessage((prevState) => ({
      ...prevState,
      state: 2,
      type: "error",
      title: "State the Reason for Rejection",
      description: "",
      buttonText: "Reject",
    }));
  };

  const redirectToOrderPage = (status) => {
    if (isPharmacy && status === "approve") {
      history.push(App.ORDER_DEFAULT + pafID);
    } else {
      history.push(App.VIEW_PATIENTS);
    }
  };

  const previous = () => {
    history.push(App.NOTIFICATIONS);
  };

  if (isLoading) return <Loader />;

  return (
    <StyledPrescriptionAuthorisationForm>
      <div className="layout-modal">
        <div className="close-icon" onClick={closeForm}>
          <img src={CloseIcon} alt="Close Icon" />
        </div>
        <div className="min-height">
          <div className="wrapper-flex custom-style">
            <h1 className="select-category-txt">
              Prescription Authorisation Form
            </h1>

            <div className="wrapper-flex">
              {items.status === "Approved" ? (
                <>
                  <Valid style={{ marginRight: 29 }} />
                  <button
                    className="green-button"
                    onClick={() => redirectToOrderPage("approve")}
                  >
                    Finish
                  </button>
                </>
              ) : items.status === "Rejected" ? (
                <>
                  <Rejected style={{ marginRight: 29 }} />
                  <button
                    className="green-button"
                    onClick={() => redirectToOrderPage("reject")}
                  >
                    Finish
                  </button>
                </>
              ) : (
                (items.status === "Overdue" ||
                  items.status === "Expiring" ||
                  items.status === "Submitted") && (
                  <div className="approve-reject-paf">
                    <button
                      className="green-button mr-4"
                      onClick={approveForm}
                      disabled={isButtonDisabled}
                    >
                      Approve <ArrowNextWhite />
                    </button>
                    <button
                      className="red-button"
                      disabled={isButtonDisabled}
                      onClick={rejectForm}
                    >
                      Reject <ArrowNextWhite />
                    </button>
                  </div>
                )
              )}
            </div>
          </div>
          <div className="red-label">{errorMessage}</div>
          <InfoPAF patientDetails={userInfo} />

          <div className="wrapper-pannel mt-5">
            <ViewPAF
              form={isObject(items) ? items : items[0]}
              isPrint={false}
              numberOfCylesValues={numberOfCylesValues}
            />
          </div>
        </div>
        {!(items.status === "Approved") && !(items.status === "Rejected") && (
          <div className="wrapper-buttons-select-type">
            <div className="padding-15">
              <button onClick={previous} className="prev">
                Previous
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />

      {quitModalIsOpen && (
        <QuitModal
          quitModalIsOpen={quitModalIsOpen}
          closeModalQuit={closeModalQuit}
          quitModal={quitModal}
          description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
        />
      )}

      {statePAFModal && (
        <ConfirmationModal
          setIsButtonDisabled={setIsButtonDisabled}
          statePAFModal={statePAFModal}
          closeConfirmationModal={closeConfirmationModal}
          message={message}
          submitError={submitError}
          setErrorMessage={setErrorMessage}
        />
      )}
    </StyledPrescriptionAuthorisationForm>
  );
};
export default PAFDetails;
